export const externalLinkDatas = () => {
  const lang = {
    'ja': 'ja'
  }[localStorage.getItem('locale') || window.navigator.language || navigator.userLanguage] || 'en'
  return {
    'compassbioinfo': {
      'ja': 'https://compassbioinfo.jp/',
      'en': 'https://compassbioinfo.com/'
    }[lang],
    'inherinext': {
      'ja': 'https://edge.inherinext.jp/',
      'en': 'https://edge.inherinext.com/'
    }[lang]
  }
}



// WEBPACK FOOTER //
// ./src/constants/global/data.js